var map = {
	"./Cancel.svg": 179,
	"./Containerschiff-1.png": 258,
	"./Dashboard-icon.svg": 101,
	"./Edit-icon-black.svg": 259,
	"./Edit-icon.svg": 260,
	"./Map-icon.svg": 261,
	"./Map.svg": 262,
	"./Message-icon.svg": 102,
	"./Message.svg": 263,
	"./Monitor-icon.svg": 66,
	"./Order-icon.svg": 35,
	"./Polygon-blue.svg": 264,
	"./Polygon-darkBlue.svg": 265,
	"./Polygon-darkGreen.svg": 266,
	"./Polygon-darkPink.svg": 267,
	"./Polygon-grey.svg": 268,
	"./Polygon-orange.svg": 269,
	"./Polygon-red.svg": 270,
	"./Question-stroke-icon.svg": 271,
	"./Settings-icon.svg": 272,
	"./Shopping-cart-icon.svg": 273,
	"./Shopping-cart.svg": 138,
	"./Spinner-1s-200px.gif": 5,
	"./Upload-link.svg": 274,
	"./admin-icon.svg": 275,
	"./arrow-right.svg": 276,
	"./avatar.svg": 277,
	"./block-icons.svg": 278,
	"./cancel-icon.svg": 139,
	"./certificate-01.png": 103,
	"./certificate-02.png": 140,
	"./change-password-ico.png": 159,
	"./chat-box.png": 180,
	"./check-icon.png": 279,
	"./circleOutlineWithExclamation.svg": 280,
	"./circle_outline_with_exclamation.svg": 104,
	"./correct-icon.svg": 181,
	"./correct.svg": 22,
	"./correct2.svg": 20,
	"./delete-icon.svg": 94,
	"./editpen-icon.svg": 95,
	"./emoji.png": 160,
	"./image1.jpg": 281,
	"./img01.png": 282,
	"./img02.png": 283,
	"./img03.png": 284,
	"./img04.png": 73,
	"./img05.png": 74,
	"./img06.png": 75,
	"./info-icon.svg": 285,
	"./left-arrow.svg": 54,
	"./location-icon.png": 286,
	"./login-bg.jpg": 48,
	"./logo.png": 47,
	"./logout.svg": 136,
	"./market-img1.png": 182,
	"./market-img2.png": 183,
	"./market-img3.png": 184,
	"./market-img4.png": 185,
	"./market-img5.png": 186,
	"./market-img6.png": 187,
	"./mesh-popup-img.png": 188,
	"./mesh-popup-img2.png": 189,
	"./no-image-found.png": 287,
	"./old-login-bg.jpg": 288,
	"./polygon-green.svg": 289,
	"./sidebar-icons/admin.svg": 290,
	"./sidebar-icons/barque.svg": 291,
	"./sidebar-icons/check-list.svg": 292,
	"./sidebar-icons/checked.svg": 293,
	"./sidebar-icons/chef.svg": 294,
	"./sidebar-icons/coupon.svg": 295,
	"./sidebar-icons/customer.svg": 296,
	"./sidebar-icons/dashboard-1.svg": 297,
	"./sidebar-icons/dashboard-interface.svg": 298,
	"./sidebar-icons/dashboard.svg": 299,
	"./sidebar-icons/delivery-truck.svg": 300,
	"./sidebar-icons/department.svg": 301,
	"./sidebar-icons/germany.svg": 302,
	"./sidebar-icons/inventory.svg": 303,
	"./sidebar-icons/label.svg": 304,
	"./sidebar-icons/logout.svg": 305,
	"./sidebar-icons/market-img5.png": 306,
	"./sidebar-icons/packages.svg": 307,
	"./sidebar-icons/port.svg": 308,
	"./sidebar-icons/price-tag.svg": 309,
	"./sidebar-icons/review.svg": 310,
	"./sidebar-icons/rudder.svg": 311,
	"./sidebar-icons/ship.svg": 312,
	"./sidebar-icons/upgrade.svg": 313,
	"./sidebar-icons/upload-1.svg": 314,
	"./sidebar-icons/upload.svg": 315,
	"./sidebar-icons/web-browser.svg": 316,
	"./special offer.png": 190,
	"./star.png": 317,
	"./stars-bg.svg": 318,
	"./supplier-icon1.svg": 178,
	"./supplier-icon2.svg": 319,
	"./supplier-logo.png": 41,
	"./svg-loader.svg": 320,
	"./user.svg": 105,
	"./validation-icon.svg": 321
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 137;